import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/movie', label: '电影' },
    { to: '/category/tv', label: '电视剧' },
    { to: '/category/anime', label: '动漫' },
    { to: '/category/variety', label: '综艺' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 ${scrolled ? 'text-foreground-900' : 'text-white'}`}
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-movie-2-line text-2xl ${scrolled ? 'text-primary-500' : 'text-primary-400'}`}></i>
            </div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">悟空影视</span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                  location.pathname === link.to
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className={`hidden md:flex items-center gap-2 px-4 py-2 rounded-full text-sm border transition-all duration-200 ${
              scrolled
                ? 'bg-background-100 border-background-200 text-foreground-600'
                : 'bg-white/10 border-white/20 text-white/70'
            }`}>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="搜索影片..."
                className={`bg-transparent outline-none w-32 text-sm placeholder-current ${
                  scrolled ? 'text-foreground-800' : 'text-white'
                }`}
              />
            </div>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
                scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white hover:bg-white/10'
              }`}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-background-50 border-t border-background-200/70 py-3 px-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="md:hidden mt-3 px-4 py-3">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full text-sm bg-background-100 border border-background-200 text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索影片..."
                  className="bg-transparent outline-none w-full text-sm text-foreground-800"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}